<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ isEditMode ? $t("app_catalog.edit_product_title", { id: routeId }) : $t("products") }}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-breadcrumb />
                    </nav>
                </div>
                <!-- §5 B5: create mode only — leftmost of the header buttons. -->
                <div class="col-lg-6 col-5 text-right">
                    <form-clear-button v-if="!isEditMode" @click="clearForm" />
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <validation-observer ref="formValidator">
                <form class="new-event--form">
                    <div class="card mb-4">
                        <!-- Card header -->
                        <div class="card-header"><h3 class="mb-0">{{ $t("products") }}</h3></div>
						 <!-- Card body -->
                        <div class="card-body">
                            <!-- Form groups used in grid -->
                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('name')" :name="$t('name')" v-model="params.name" rules="required" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('product_code')" :name="$t('product_code')" v-model="params.code" rules="required" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('tag')" :name="$t('tag')" v-model="params.tag" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('product_category')">
                                        <el-select v-model=" params.bo_product_category_id " :name="$t('product_category')" :placeholder=" $t('product_category') " filterable >
                                            <el-option v-for="option in ProductCategoryTable" :key="option.id" :label="option.name" :value="option.id" > </el-option>
                                        </el-select>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('detail')">
                                        <textarea class="form-control" rows="3" v-model="params.detail" ></textarea>
                                    </base-input>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('price')" :name="$t('price')" v-model.number="params.price" rules="required|numeric" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('shipping_cost')" :name="$t('shipping_cost')" v-model.number="params.shopping_cost" rules="required|numeric" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('status')">
                                        <el-select
                                            v-model="params.status"
                                            :name="$t('status')"
                                            :placeholder="$t('status')"
                                            filterable
                                        >
                                            <el-option
                                                v-for="option in ProductStatusTable"
                                                :key="option.id"
                                                :label="option.name"
                                                :value="option.id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>
                            </div>
                            <!-- Spec 2026-10-07-bo-form-draft-clear-design.md §5 B4: the "แอป (หน้าขายสินค้า)"
                                 section is gone from the screen (the App uses the seller catalog). The five
                                 app_* values still travel in the payload — see params / loadForRoute. -->

                            <div class="row">
                                <div class="col-md-6">
                                    <base-input :label="$t('visibility')">
                                        <el-select
                                            v-model="params.visibility"
                                            :name="$t('visibility')"
                                            :placeholder="$t('visibility')"
                                        >
                                            <el-option :label="$t('visibility_all')" :value="0"></el-option>
                                            <el-option :label="$t('visibility_company_only')" :value="1"></el-option>
                                            <el-option :label="$t('visibility_agent_only')" :value="2"></el-option>
                                        </el-select>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-8">
                                    <label class="form-control-label">{{ $t('price_tiers') }}</label>
                                    <small class="form-text text-muted">{{ $t('price_tiers_hint') }}</small>
                                    <table class="table table-sm mt-2 mb-2" v-if="params.price_tiers.length > 0">
                                        <thead>
                                            <tr>
                                                <th>{{ $t('tier_min_qty') }}</th>
                                                <th>{{ $t('tier_price') }}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(tier, idx) in params.price_tiers" :key="idx">
                                                <td><input type="number" min="1" class="form-control form-control-sm" v-model.number="tier.min_qty" /></td>
                                                <td><input type="number" min="0" step="0.01" class="form-control form-control-sm" v-model.number="tier.price" /></td>
                                                <td>
                                                    <base-button type="danger" size="sm" @click.native="removeTier(idx)">
                                                        <i class="fa fa-trash"></i>
                                                    </base-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <base-button size="sm" type="primary" @click.native="addTier()">
                                        <i class="fa fa-plus"></i> {{ $t('add_tier') }}
                                    </base-button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input :label="$t('image')" :name="$t('image')" >
                                        <file-input ref="imageInput" rules="required" @change="filesChange" ></file-input>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
									<img :src="GetProductUrl(params.images)" height="200px" v-if="params.images.includes('.png') || params.images.includes('.jpg') || params.images.includes('.jpeg')"/>
                                    <img v-if="!params.images.includes('.png') && !params.images.includes('.jpg') && !params.images.includes('.jpeg')  && params.images != '' && params.images != null && params.images != undefined " :src="params.images" height="200px" />
                                </div>
                            </div>

							<!-- Variable -->
                            <div class="row py-4">
                                <div class="col-md-1 pb-3">
                                    Variable
                                </div>
                                <div class="col-md-6">
                                    <base-button size="sm" v-if="attributes.length <= 15" @click="handleAddVariable()" >Add Variable</base-button >
                                </div>
                            </div>

                            <!-- Is Comboset Checkbox (only show when exactly 1 variable) -->
                            <div class="row py-2" v-if="attributes.length === 1">
                                <div class="col-md-6">
                                    <base-checkbox v-model="params.is_comboset">
                                        {{ $t('is_comboset') }}
                                    </base-checkbox>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <div v-for="(attribute, index) in attributes" :key="index" class="row py-2" >
                                        <div class="col-md-6 col-lg-3">
                                            <base-input v-model="attribute.variable" size="sm"/>
                                        </div>

                                        <div class="col-md-6 col-lg-3">
                                            <base-button @click=" handleRemoveVariable(index) " type="danger" >
												 <i class="fa fa-trash"></i>
											</base-button>
                                            <base-button v-if="attributes.length < 12" @click=" handleCopyVariable( index) " type="primary" > <i class="fa fa-file"></i ></base-button>
                                            <base-button @click="handleManageOption(attribute)" type="primary">
                                                <i class="fa fa-plus"></i>
											</base-button>
                                        </div>

                                        <div class="col-md-12 col-lg-12">
											<template v-for="(option, index) in attribute.options" >
												<span class="badge badge-pill badge-primary text-white mr-2 py-2 pb-2" v-if="option.wms_map[0].wms_product_id != 0" :key="index">
													{{ option.name }}
												</span>
												<span class="badge badge-pill badge-primary text-orange mr-2 py-2 pb-2" v-if="option.wms_map[0].wms_product_id == 0" :key="index">
													{{ option.name }}
												</span>
											</template>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <hr />
                            <div class="row">
                                <div class="col-md-12">
                                    <base-button @click="handleSaveProduct()" type="primary" >{{ $t("save") }}</base-button >
									<base-button size="md" type="secondary" @click="$router.go(-1)">{{ $t("back") }}</base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </validation-observer>
        </div>

		<!-- Variable Modal -->
        <modal :show.sync="showAddVariable" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
					<div class="col md-3">
						<base-input :label="$t('name')" v-model="variableName"></base-input>
					</div>
            </form>

            <template slot="footer">
                <button type="submit" class="btn btn-md btn-primary" @click="handleUpdateVariable()" > {{ $t("add") }} </button>
                <button type="button" class="btn btn-md btn-link ml-auto" @click="showAddVariable = false" > {{ $t("close") }} </button>
            </template>
        </modal>

		<!-- Option Modal	-->
        <modal :show.sync="showManageOption" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <label for="">Variable : {{ attr.variable }}</label>
                <div class="row pb-3">
					<div class="col-md-10">
                        <base-input>
                            <el-select v-model="wms_product_id" :placeholder="$t('product')" :label="$t('product')" filterable @change="handleWmsMapChange">
                                <el-option v-for="option in WmsProductTable" :key="option.ID" :label="option.Name" :value="option.ID"/>
                            </el-select>
                        </base-input>
                    </div>

                    <div class="col-md-2">
                        <base-button size="md" @click="handleAddOption()" type="primary" > <i class="fa fa-plus"></i ></base-button>
                    </div>
                </div>

                <div class="row pb-3">
					<div class="col-md-10">
						<base-input>
							<el-select v-model="bo_product_random" value-key="id"  :placeholder="$t('product_random')" :label="$t('product_random')" filterable>
								<el-option v-for="(option,index) in SkuRandomTable"  :key="index" :label="option.name" :value="option"/>
							</el-select>
						</base-input>
					</div>

					<div class="col-md-2">
						<base-button size="md" @click="handleAddRandomOption()" type="primary" > <i class="fa fa-plus"></i ></base-button>
					</div>
				</div>

				<!-- option (wms) -->
				<div class="row py-2" v-for="(option,index) in attr.options" :key="index">
					<div class="col-md-10">
						{{ option.name }}
					</div>
					<div class="col-md-2">
						<base-button size="md" @click="handleRemoveOption(attr.options,index)" type="danger" > <i class="fa fa-trash"></i ></base-button>
					</div>
				</div>

            </form>

            <template slot="footer">
                <button type="button" class="btn btn-md btn-link ml-auto" @click="showManageOption = false" >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

        <modal :show.sync="showMapWms" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <label for="">WMS Map</label>

                <div class="row pb-3">
                    <div class="col-md-7">
                        <base-input>
                            <el-select v-model="wms_product_id" :placeholder="$t('product')" :label="$t('product')" filterable >
                                <el-option v-for="option in WmsProductTable" :key="option.ID" :label="option.Name" :value="option.ID" > </el-option>
                            </el-select>
                        </base-input>
                    </div>
                    <div class="col-md-3">
                        <base-input :placeholder="$t('quantity')" v-model="quantity" > </base-input>
                    </div>
                    <div class="col-md-2">
                        <base-button size="md" @click="handleAddWmsProduct()" type="primary" ><i class="fa fa-plus"></i></base-button>
                    </div>
                </div>

                <div class="row">
                    <div
                        class="col-md-10"
                        v-if="products_sku[product_sku_index] != undefined"
                    >
                        <div
                            v-for="(option, index) in products_sku[
                                product_sku_index
                            ].wms_map"
                            :key="index"
                            class="row"
                        >
                            <div class="col-md-10 pb-3">
                                {{ GetProductName(option.wms_product_id) }} -
                                {{ option.pickup_quantity }}
                            </div>
                            <div class="col-md-2">
                                <base-button
                                    size="sm"
                                    @click="handleRemoveWmsProduct(index)"
                                    type="danger"
                                >
                                    <i class="fa fa-trash"></i
                                ></base-button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <template slot="footer">
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showMapWms = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import FileInput from "@/components/Inputs/FileInput";
import FormClearButton from "@/components/FormClearButton";
import formDraft from "@/mixins/formDraft";
import { consumeRefresh } from "@/utils/pageRefresh";
import {
    routeProductId,
    viewOwnsRoute,
    appFieldsFrom,
    parseSkuWmsMaps,
    parseAttributes,
    parsePriceTiers
} from "@/utils/adminProductForm";
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";

// /admin/product/form (create) and /admin/product/form/:id (edit).
// Spec: docs/specs/2026-10-07-bo-form-draft-clear-design.md §5 B1–B5.
// The product is loaded from GET /api/v1/products/:id (Product/getDetail — an
// action that stores nothing in Vuex) by the route id and lives only in this
// instance's data; each product is its own taskbar tab (key = path).
export default {
    name: "form-elements",
    mixins: [formDraft],
    components: {
        FileInput,
        FormClearButton,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            showAddVariable: false,
            showManageOption: false,
            showMapWms: false,
            variableName: "",
            attr: [],
            attr_option: {
				name: "",
				wms_map: []
			},
            products_sku: [],
            params: {
                id: 0,
                name: "",
                detail: "",
                price: "",
                images: "",
                code: "",
                attributes: "",
                tag: "",
                status: "",
                bo_product_category_id: 1,
                products_sku: null,
				platform_product_id:"",
				platform_id:1,
				shipping_cost:0,
                cod: 0,
                is_comboset: false,
                visibility: 0,
                price_tiers: [],
                // §5 B4: not on screen any more, but PUT /api/v3/products/:id
                // writes all five (Select(... app_* ...).Updates) — they are
                // filled from the loaded product and sent back unchanged so a
                // save never zeroes them. Create sends these defaults
                // (= appFieldDefaults() in @/utils/adminProductForm).
                app_enable: false,
                app_tag: "",
                app_discount: 0,
                app_discount_start: null,
                app_discount_end: null,
                // V3 update writes stock_sync_enabled — carry the row's value
                // through the save so an untouched form is a no-op.
                stock_sync_enabled: 0

            },
            attributes: [],
            sku: {},
            selectedWmsProduct: 0,
            wms_product_id: "",
            bo_product_random: "",
            quantity: "",
            product_sku_index: 0,
            inputs: {
                file: []
            },
            ProductStatusTable: [
                { id: 1, name: "ใช้งาน" },
                { id: 2, name: "ไม่ใช้งาน" }
            ],
            sku_file_index: 0
        };
    },
    computed: {
        ...mapGetters({
            WmsProductTable: "WmsProduct/getData",
            SkuRandomTable: "Product/getDataSkuRandom",
            ProductCategoryTable: "ProductCategory/getData"
        }),
        routeId() {
            return routeProductId(this.$route);
        },
        isEditMode() {
            return this.routeId !== "";
        }
    },
    watch: {
        // Same instance, different id (only possible when the view is not keyed
        // per path). A kept-alive instance of ANOTHER product tab sees every
        // route change too — viewOwnsRoute keeps it out (§5 B3).
        $route(to) {
            if (!to || to.name !== "product_form") return;
            if (!viewOwnsRoute(this.$vnode ? this.$vnode.key : undefined, to)) return;
            if (routeProductId(to) === this.formRouteId) return;
            this.loadForRoute();
        }
    },
    created() {
        // The list's requestRefresh() is for THIS arrival, which created()
        // already loads — consume it so the first activated() does not load
        // twice.
        consumeRefresh(this.$route.fullPath);
        this.loadForRoute();
    },
    activated() {
        // §5 B2: a plain tab switch keeps the draft; only an arrival with
        // intent ("แก้ไข" clicked on the list) reloads the product. In create
        // mode the flag is consumed but the draft is kept — owner §1: "ถ้ายัง
        // ไม่ได้บันทึกให้ค้างข้อมูลเดิมไว้"; the form empties after a save.
        if (consumeRefresh(this.$route.fullPath) && this.isEditMode) {
            this.loadForRoute();
        }
    },
    mounted() {
		// Clear Class
		document.body.classList.remove("modal-open");

		// Shared lookup lists (not the product being edited — §5 B3).
		this.listSkuRandom();
        this.listWMS();
        this.listProductCategory();
    },
    methods: {
        ...mapActions({
            // V3 endpoints — V1 create/update silently drop the App
            // shopping-page fields (app_*) and stock_sync_enabled.
            createData: "Product/createDataV3",
            updateData: "Product/updateDataV3",
            listWMS: "WmsProduct/listData",
            listSkuRandom: "Product/listSkuRandom",
            listProductCategory: "ProductCategory/listData",
            // GET /api/v1/products/:id → resp.data.Datum (DBProduct + products_sku)
            getDetail: "Product/getDetail"
        }),
        // formDraft contract (§3 F1): every field back to its initial state.
        resetForm() {
            Object.assign(this.$data, this.$options.data.call(this));
            const input = this.$refs.imageInput;
            if (input) {
                if (typeof input.clearFile === "function") input.clearFile();
                // FileInput keeps the chosen name in `files` for its label.
                if (Array.isArray(input.files)) input.files = [];
                const el = input.$el && input.$el.querySelector ? input.$el.querySelector("input") : null;
                if (el) el.value = "";
            }
            const observer = this.$refs.formValidator;
            if (observer && typeof observer.reset === "function") observer.reset();
        },
        // §5 B2: create mode = empty form; edit mode = the product from the API.
        async loadForRoute() {
            const id = routeProductId(this.$route);
            this.formRouteId = id;
            this.formLoadSeq = (this.formLoadSeq || 0) + 1;
            const seq = this.formLoadSeq;
            this.resetForm();
            if (id === "") return;

            let product = null;
            try {
                const resp = await this.getDetail(id);
                product = resp && resp.data ? resp.data.Datum : null;
            } catch (err) {
                console.log(err);
            }
            // A newer load (another id / another intent) started meanwhile.
            if (seq !== this.formLoadSeq) return;
            if (!product) {
                swal.fire({
                    title: this.$t("error"),
                    text: this.$t("app_catalog.expand_load_failed"),
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }
            this.applyProduct(product);
        },
        applyProduct(p) {
            this.params.id = p.id;
            this.params.name = p.name;
            this.params.detail = p.detail;
            this.params.price = p.price;
            this.params.images = p.images || "";
            this.params.code = p.code;
            this.params.shipping_cost = p.shipping_cost;

            this.attributes = parseAttributes(p.attributes);
            this.params.attributes = parseAttributes(p.attributes);

            this.params.tag = p.tag;
            this.params.status = p.status;
            this.params.bo_product_category_id = p.bo_product_category_id;
            // params.products_sku stays null: this form never sent SKUs (the
            // old row field `product_sku` did not exist), and V3 persists any
            // products_sku[].wms_map it receives (#246) — keep it that way.
            this.products_sku = parseSkuWmsMaps(p.products_sku);

            // V3 save writes every column below — populate them from the loaded
            // product so saving an untouched form never clobbers a value.
            this.params.cod = p.cod || 0;
            this.params.platform_id = p.platform_id || 1;
            this.params.platform_product_id = p.platform_product_id || "";
            this.params.stock_sync_enabled = p.stock_sync_enabled || 0;

            // is_comboset 1/0 -> boolean for the checkbox
            this.params.is_comboset = p.is_comboset == 1;

            // Backend stores visibility as int (0/1/2); coerce so el-select's
            // :value="0" options match strictly.
            this.params.visibility = Number(p.visibility) || 0;
            this.params.price_tiers = parsePriceTiers(p.price_tiers);

            // §5 B4: hidden but carried — see the comment on params.
            Object.assign(this.params, appFieldsFrom(p));
        },
        addTier() {
            this.params.price_tiers.push({ min_qty: 0, price: 0 });
        },
        removeTier(idx) {
            this.params.price_tiers.splice(idx, 1);
        },
        // Returns a localized error message when any tier is invalid, or
        // an empty string when all rows pass. Mirrors NormalizePriceTiers
        // on the backend so the user gets the same rules either way.
        validatePriceTiers() {
            const tiers = this.params.price_tiers || [];
            if (tiers.length === 0) return "";

            const seenMinQty = new Set();
            for (let i = 0; i < tiers.length; i++) {
                const t = tiers[i];
                const minQty = Number(t.min_qty);
                const price = Number(t.price);
                const rowLabel = "#" + (i + 1);

                if (!Number.isInteger(minQty) || minQty < 1) {
                    return rowLabel + ": " + this.$t("tier_min_qty_invalid");
                }
                if (!Number.isFinite(price) || price <= 0) {
                    return rowLabel + ": " + this.$t("tier_price_invalid");
                }
                if (seenMinQty.has(minQty)) {
                    return rowLabel + ": " + this.$t("tier_min_qty_duplicate") + " (" + minQty + ")";
                }
                seenMinQty.add(minQty);
            }
            return "";
        },
        GetProductName(wms_product_id) {
            let product = this.WmsProductTable.find(s => {
                return s.ID == wms_product_id;
            });
            if (product == undefined) {
                return "";
            } else {
                return product.Name;
            }
        },
        async handleSaveProduct() {
            // Edit mode whose product did not load (or is still loading): never
            // fall through to "create", never PUT an empty form over it.
            if (this.isEditMode && String(this.params.id) !== this.routeId) {
                swal.fire({
                    title: this.$t("error"),
                    text: this.$t("app_catalog.expand_load_failed"),
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }
            let valid = await this.$refs.formValidator.validate();
            if (!valid) return;

			// Status: el-select has no built-in VeeValidate rule, so reject
			// empty string here. params.status default is "" until the user
			// picks one; 1/2 are the only valid options.
			if (this.params.status === "" || this.params.status === null || this.params.status === undefined) {
				swal.fire({
					title: this.$t("error"),
					text: this.$t("status_required"),
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			// Price Tiers: validate before NormalizePriceTiers runs server-side.
			// Catching here avoids a round-trip and keeps the UX message in
			// the user's language.
			const tiersBad = this.validatePriceTiers();
			if (tiersBad) {
				swal.fire({
					title: this.$t("error"),
					text: tiersBad,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			// check attributes
			if (this.attributes.length == 0) {
				swal.fire({
					title: this.$t("error"),
					text: "Variable is empty",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			// Reject duplicate Variable names — two variables with the same
			// label would collide on the generated SKU code (code-OptA-OptB).
			const variableNames = this.attributes.map(a => (a.variable || "").trim().toLowerCase()).filter(v => v);
			const variableDup = variableNames.find((v, i) => variableNames.indexOf(v) !== i);
			if (variableDup) {
				swal.fire({
					title: this.$t("error"),
					text: this.$t("variable_duplicate") + ": " + variableDup,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			//  Check Variable
			valid = true
			await this.attributes.forEach(attr => {
				if (attr.variable == "") {
					swal.fire({
						title: this.$t("error"),
						text: "Variable name is empty",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					valid = false
					return;
				}

				if (attr.options.length == 0) {
					swal.fire({
						title: this.$t("error"),
						text: "Variable "+ attr.variable + " options is empty",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					valid = false
					return;
				}

				// Reject duplicate Option names within the same Variable.
				const optNames = attr.options.map(o => (o.name || "").trim().toLowerCase()).filter(n => n);
				const optDup = optNames.find((n, i) => optNames.indexOf(n) !== i);
				if (optDup) {
					swal.fire({
						title: this.$t("error"),
						text: attr.variable + ": " + this.$t("option_duplicate") + " (" + optDup + ")",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
					valid = false
					return;
				}

				attr.options.forEach(option => {
					if (option.name == "") {
						swal.fire({
							title: this.$t("error"),
							text: "Option name is empty",
							icon: "error",
							confirmButtonClass: "btn btn-danger btn-fill",
							buttonsStyling: false
						});
					valid = false
						return;
					}
				});
			});

			if (!valid) return;

			// Check params string contain .png
			if (this.params.images.includes(".png") || this.params.images.includes(".jpg") || this.params.images.includes(".jpeg")) {
				this.params.images = ""
			}
			
			


            this.params.attributes = this.attributes;

            // Convert is_comboset boolean to 1 or 0
            this.params.is_comboset = this.params.is_comboset ? 1 : 0;

            // App fields: checkbox -> 1/0, discount -> number
            this.params.app_enable = this.params.app_enable ? 1 : 0;
            this.params.app_discount = Number(this.params.app_discount) || 0;

            if (this.params.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        console.log(resp);
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                        // §5 B5: the create tab is empty the next time it opens.
                        this.afterSaveReset();
                        this.$router.push({ name: "product" });
                    })
                    .catch(err => {
                        console.log(err);
                        swal.fire({
                            title: err.response.data.Cause,
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
                // Update
				if (this.fileNameIsImage(this.params.images)){
					this.params.images = ""
				}
                this.updateData({ id: this.params.id, payload: this.params })
                    .then(resp => {
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                        this.$router.push({ name: "product" });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: "",
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },

		// Manage Variable
        handleAddVariable() {
            this.variableName = "";
            this.showAddVariable = true;
        },
        handleUpdateVariable() {
            this.showAddVariable = false;

            this.attributes.push({
                variable: this.variableName,
                options: []
            });
        },
        handleRemoveVariable(index) {
            this.attributes.splice(index, 1);
        },
		handleCopyVariable(index){
			let attribute = JSON.parse(JSON.stringify(this.attributes[index]))
            this.attributes.push(attribute);
		},

		// ManageOption
        handleManageOption(attribute) {
            this.showManageOption = true;
			this.attr = attribute

			this.attr_option = {
				name: "",
				wms_map: []
			}
        },
        handleAddOption() {
			//add new
			this.attr_option.name = this.WmsProductTable.find(s => {
				return s.ID == this.wms_product_id;
			}).Name;

			this.attr_option.wms_map = [];
			this.attr_option.wms_map.push({
				wms_product_id: this.wms_product_id,
				wms_product_name: this.WmsProductTable.find(s => {
					return s.ID == this.wms_product_id;
				}).Name,
				pickup_quantity: 1
			})

			this.attr.options.push(JSON.parse(JSON.stringify(this.attr_option)))



        },
		handleAddRandomOption(){
			this.attr_option.name = this.bo_product_random.name
			this.attr_option.wms_map = [];
			this.attr_option.wms_map.push({
				wms_product_id: 0,
				pickup_quantity: 1,
				wms_product_name: this.bo_product_random.name,
				wms_product_random : {
					bo_product_random_id: this.bo_product_random.id,
				}
			})

			this.attr.options.push(JSON.parse(JSON.stringify(this.attr_option)))

		},
        handleRemoveOption(options, index) {
			options.splice(index, 1);
        },
        AddOrUpdateSku(sku_name,wms_map) {
            let sku = this.products_sku.find(s => s.name == sku_name);

            if (sku == undefined) {
                this.products_sku.push({
					id:0,
                    sku_name: sku_name,
                    sku_code: this.params.code + "-" + sku_name,
                    price: this.params.price,
                    image: "",
					quantity:1,
                    wms_map: wms_map
                });
            }
        },
		handleWmsMapChange(){
			// set option name with wms_product_id
			try {
				this.attr_option.name = this.WmsProductTable.find(
					s => s.ID == this.wms_product_id
				).Name;
				console.log(this.attr_option.name)
			}
			catch(err){
				console.log(err)
			}

		},

        handleMapWms(product_sku_index) {
            this.showMapWms = true;
			this.quantity = 1;
            this.product_sku_index = product_sku_index;
        },
        handleAddWmsProduct() {
            let sku = this.products_sku[this.product_sku_index].wms_map.find(
                s => s.wms_product_id == this.wms_product_id
            );

            if (sku == undefined) {
                this.products_sku[this.product_sku_index].wms_map.push({
                    wms_product_id: this.wms_product_id,
                    pickup_quantity: parseInt(this.quantity)
                });
            } else {
                sku.pickup_quantity = parseInt(this.quantity);
            }
        },
		handleAddSkuRandom() {
            let sku = this.products_sku[this.product_sku_index].wms_map.find((s)=>{
				try {
					return s.sku_random_id == this.sku_random_id
				} catch (error) {
					console.log(error)
					return false
				}
			});

            if (sku == undefined) {
                this.products_sku[this.product_sku_index].wms_map.push({
                    wms_product_id: 0,
                    sku_random_id: this.sku_random_id,
                    pickup_quantity: parseInt(this.quantity)
                });
            } else {
                sku.pickup_quantity = parseInt(this.quantity);
            }
        },
        handleRemoveWmsProduct(index) {
            this.products_sku[this.product_sku_index].wms_map.splice(index, 1);
        },

        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }

			console.log(files[0].size)

			if (files[0].size > 1024 * 1024 *2) {
				swal.fire({
                    title: "Error",
                    text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 2 MB",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
			}
            // convert to base64
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                this.params.images = reader.result;
            };
        },
        SkuFileChange(files) {
			

            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
            }
			console.log(files[0].size)

			if (files[0].size > 1024 * 1024 ) {
				swal.fire({
                    title: "Error",
                    text: "ขนาดไฟล์รูปภาพต้องไม่เกิน 1 MB",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
                return;
			}
            // convert to base64
            const reader = new FileReader();
            reader.readAsDataURL(files[0]);
            reader.onload = () => {
                this.products_sku[this.sku_file_index].image = reader.result;
            };
        },
		GetProductUrl(filename){
			return process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
		},
		fileNameIsImage(filename) {
			return filename.includes(".png") || filename.includes(".jpg") || filename.includes(".jpeg")
		}

    }
};
</script>
